/**
 * Asambleas — "Agregar a mi calendario" (puro, sin Firebase).
 *
 * Google Calendar y Outlook se abren con un enlace prellenado; el archivo .ics
 * (Apple Calendar y el resto) lo sirve el servidor con UID estable y SEQUENCE =
 * versión, así una reprogramación actualiza el evento en vez de duplicarlo.
 */

const TZ = "America/Montevideo";

const pad = (n) => String(n).padStart(2, "0");

/** 20261104T220000Z */
function utcStamp(ms) {
  const d = new Date(ms);
  return (
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
    `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
  );
}

function rango(asamblea) {
  const inicio = Number(asamblea.inicioMs);
  if (!Number.isFinite(inicio)) throw new Error("La asamblea no tiene fecha");
  const fin = inicio + Math.max(30, Number(asamblea.duracionMin) || 120) * 60 * 1000;
  return { inicio, fin };
}

/**
 * @param {{inicioMs: number, duracionMin?: number}} asamblea
 * @param {{titulo: string, detalle?: string, lugar?: string}} texto
 */
export function enlaceGoogleCalendar(asamblea, { titulo, detalle = "", lugar = "" }) {
  const { inicio, fin } = rango(asamblea);
  const q = new URLSearchParams({
    action: "TEMPLATE",
    text: titulo,
    dates: `${utcStamp(inicio)}/${utcStamp(fin)}`,
    details: detalle,
    location: lugar,
    ctz: TZ,
  });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
}

/** Outlook (cuentas personales y de Microsoft 365 con `trabajo: true`). */
export function enlaceOutlook(asamblea, { titulo, detalle = "", lugar = "" }, { trabajo = false } = {}) {
  const { inicio, fin } = rango(asamblea);
  const q = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: titulo,
    startdt: new Date(inicio).toISOString(),
    enddt: new Date(fin).toISOString(),
    body: detalle,
    location: lugar,
  });
  const host = trabajo ? "outlook.office.com" : "outlook.live.com";
  return `https://${host}/calendar/0/deeplink/compose?${q.toString()}`;
}

/**
 * Texto del evento: título y detalle con el orden del día (sin datos de Zoom).
 * Con `t` (el del namespace asambleas, ya en el idioma del propietario) sale en
 * ese idioma; sin `t`, en español.
 */
export function textoDelEvento(asamblea, nombreEdificio, t = null) {
  const tipo = asamblea.tipo === "extraordinaria" ? "extraordinaria" : "ordinaria";
  const puntos = (asamblea.ordenDelDia || []).map((p, i) => `${i + 1}. ${p.titulo}`).join("\n");
  if (typeof t === "function") {
    const nombre = String(nombreEdificio || "").trim();
    return {
      titulo: nombre ? `${t(`tipo.${tipo}`)} — ${nombre}` : t(`tipo.${tipo}`),
      detalle: puntos ? `${t("ordenDelDia")}:\n${puntos}` : "",
      lugar: asamblea.modalidad === "remota" ? t("calendario.lugarVideo") : asamblea.lugar || "",
    };
  }
  const titulo = `Asamblea ${tipo} de copropietarios — ${nombreEdificio || "edificio"}`;
  const detalle = puntos ? `Orden del día:\n${puntos}` : "";
  const lugar = asamblea.modalidad === "remota" ? "Videollamada (el enlace llega por WhatsApp o email)" : asamblea.lugar || "";
  return { titulo, detalle, lugar };
}
